/* eslint-disable no-lonely-if */
import AnalysisHeader from '@/pages/layout/components/AnalysisHeader';
import AnalysisMenu from '@/pages/layout/components/AnalysisMenu';
import style from './Analysis.module.less';
import { Outlet, useLocation } from 'react-router-dom';
import { useRouter, useUserInfo } from '@/hooks/hooks';
import Search from './components/Search';
import { useState, useEffect } from 'react';
import { getPublishConfig } from '@/service/exam/analysis';
import { allCourseRoute, singleCourseRoute, RouteObjectWithMeta } from './router';
import { getExamCourseList } from '@/service/exam/list';


export interface CourseConfig {
  name: string; // 科目名称
  canExportStudentScore: boolean; // 可以导出 ？
  avg: boolean; // 全科分析
  group: boolean; // 全科分析的时候是 总分分段分析 单科的时候是 单科成绩分段分析
  fourRate: boolean; // 四率分析
  exportQuestionScore?: boolean;
  primaryLevel?: boolean;
}


export interface AnalysisContext{
  courseDcode: string;
  schoolAreaCode: string;
  canExportStudentScore: boolean;
  exportQuestionScore?: boolean;
  primaryLevel?: boolean;
}

const AnalysisPortal = () => {

  const router = useRouter();
  const location = useLocation();

  const { name, gradeDcode, examid } = router.getSearchParams();
  const [context, setContext] = useState<AnalysisContext>({
    courseDcode: '',
    schoolAreaCode: '',
    canExportStudentScore: false,
    exportQuestionScore: false,
    primaryLevel: false
  });

  const userInfo = useUserInfo();

  // 科目
  const [courseConfig, setCourseConfig] = useState<CourseConfig[]>([]);

  // 依据科目获取菜单
  const [routes, setRoutes] = useState<RouteObjectWithMeta[]>([]);


  // 加载可以查看分析的科目
  const loadCourses = (data: PublishData, courseList: ExamCours[]) => {
    const userType = userInfo.userType.toLowerCase();
    const c = userType === 'edu' ? data.edu : data.school;
    const courses = Object.entries(c).reduce((a, [key, value]) => {
      if (key === 'WHOLE_COURSE_T') {
        // 全科的时候
        return [...a, {
          name: key,
          canExportStudentScore: value.exportConfig.studentScore,
          exportQuestionScore: value.exportConfig.questionScore,
          primaryLevel: value.exportConfig.primaryLevel && gradeDcode.indexOf('P') !== -1,
          ...value.publishConfig
        }] as CourseConfig[];
      } else {
        return [...a, {
          name: key,
          canExportStudentScore: value.exportConfig.studentScore,
          ...value.publishConfig
        }] as CourseConfig[];
      }
    }, [] as CourseConfig[]);
    // 跟有成绩的科目再进行一次比对
    const hasScoreExams = courseList.filter(i => i.hasScore).map(i => i.coursetypeDcode);
    const hasWholeCourse = courseList.every(i => i.hasScore);
    const wholeCourseAnalysis = courses.find(i => i.name === 'WHOLE_COURSE_T');
    const finalCourse = courses.filter(i => hasScoreExams.includes(i.name));
    if (hasWholeCourse && wholeCourseAnalysis) {
      finalCourse.unshift(wholeCourseAnalysis);
    }
    setCourseConfig(finalCourse.map(gl => {return {
      ...gl,
      exportQuestionScore: wholeCourseAnalysis?.exportQuestionScore,
      primaryLevel: wholeCourseAnalysis?.primaryLevel
    };}));
  };

  const loadConfig = async () => {
    const { data } = await getPublishConfig(examid);
    const { data: prop } = await getExamCourseList(examid);
    // loadMenu();
    loadCourses(data, prop);
  };

  useEffect(() => {
    loadConfig();
  }, []);

  const courseChange = (course: string) => {
    const prop = courseConfig.find(i => i.name === course);
    if (prop) {
      setContext({
        ...context,
        courseDcode: course,
        canExportStudentScore: prop.canExportStudentScore,
        exportQuestionScore: prop.exportQuestionScore,
        primaryLevel: prop.primaryLevel
      });
      // 开始初始化 菜单
      let r: RouteObjectWithMeta[] = [];
      if (course === 'WHOLE_COURSE_T') {
        // 全科的时候
        if (prop.avg) r.push(allCourseRoute[0]);
        if (prop.group) r.push(allCourseRoute[1]);
        if (prop.canExportStudentScore || prop.exportQuestionScore || prop.primaryLevel) {
          r.push(allCourseRoute[2]);
        }
      } else {
        // 单科的时候|
        if (prop.group) r.push(singleCourseRoute[0]);
        if (prop.fourRate) r.push(singleCourseRoute[1]);
        if (prop.canExportStudentScore || prop.primaryLevel) {
          r.push(singleCourseRoute[2]);
        }
      }
      setRoutes(r);
      router.to(r[0].path + location.search, {}, { replace: true });
    }
  };

  const schoolAreaChange = (area: string) => {
    setContext({
      ...context,
      schoolAreaCode: area
    });
  };

  return (
    <div className={style.wrapper}>
      <AnalysisHeader
        title={['考试分析', ...decodeURI(name).split(',')]}
        rightNode={
          <Search
            gradeDcode={gradeDcode}
            courseConfig={courseConfig}
            onCourseChange={courseChange}
            onSchoolAreaChange={schoolAreaChange}
          />
        }
      />
      <div className={style.content}>
        <AnalysisMenu
          routes={routes}
        />
        <div className={style.container}>
          <Outlet context={context}/>
        </div>
      </div>
    </div>
  );
};

export default AnalysisPortal;
